import { React, PropTypes, FelaComponent } from '../../dependencies';

import Label from '../Label';

import * as styles from './Note.styles';

function Note({ value }) {
    return (
        <FelaComponent style={styles.note}>
            <Label marginBottom={12} messageId="expense.detail.note.label" />
            <FelaComponent style={styles.value}>{value}</FelaComponent>
        </FelaComponent>
    );
}

Note.propTypes = {
    value: PropTypes.string.isRequired,
};

export default Note;
